import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {http} from 'hiya-common/src/utils/axios'

// 分销商tab
export enum DisTributorEnum {
  // 分销
  distributor = 0,
  // 管理
  manage = 1,
}

const pageSize = 20 // 20一页
// 分销商list http://wiki.xunlei.cn/pages/viewpage.action?pageId=92470419
// kind 0获取所有分销商列表 1获取有效的分销商列表
export const getDistributorList = createAsyncThunk(
  'distributor_list',
  async (params: any, store: any) => {
    const resp = await http.post('/live/union/distributor_list', {
      ...store.getState().env.deviceinfo,
      ...params, // page 从1开始
      page_size: 100,
    })
    return {data: resp.data.data, page: params.page}
  }
)

// 币商前端进行交易（发币） http://wiki.xunlei.cn/pages/viewpage.action?pageId=90610003
export const rechargeAgencyTrade = createAsyncThunk(
  'ra_trade_ra',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/pay/ra_trade_ra',
      {
        ...store.getState().env.deviceinfo,
        ...params,
        confirm: true, // true:确认兑换
      },
      {
        xcErrorToast: true,
      }
    )
    const {err_msg, status} = resp.data.data
    if (status === 2 && err_msg) {
      onlyToast(err_msg)
    }
    return resp.data
  }
)

// 高级邀请分销商
export const seniorInviteDistributor = createAsyncThunk(
  'senior_invite_distributor',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/union/senior_invite_distributor',
      {
        ...store.getState().env.deviceinfo,
        ...params,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 高级币商查看分销商 分销以及卖币 详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96305373
// kind 1自己卖币给分销商（币商金币）记录  2 自己的分销商卖币记录 3 (分销商自己的买币记录）
export const seniorTradeHis = createAsyncThunk(
  'senior_trade_his',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/senior_trade_his', {
      ...store.getState().env.deviceinfo,
      ...params,
      page_size: pageSize,
    })
    return resp.data
  }
)

// 高级币商删除分销商 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92470022
export const deleteDistributor = createAsyncThunk(
  'senior_del_distributor',
  async (params: any, store: any) => {
    const resp = await http.post('/live/union/senior_del_distributor', {
      ...store.getState().env.deviceinfo,
      ...params,
    })
    return resp.data
  }
)

const initialState: any = {}

const initData = {
  // 有效的分销商
  distributorList: {
    page: 1,
    page_size: 20,
    more: false,
    list: [],
    kind: 0,
  },
  // 有邀请记录的分销商
  invitedDistributorList: {
    page: 1,
    page_size: 20,
    more: false,
    list: [],
    kind: 1,
  },
  // 分销记录
  tradeRecordList: {
    page: 1,
    page_size: 20,
    more: false,
    list: [],
    kind: 1,
    total: 0,
    current_amount: 0,
  },
  // 分销商卖币记录
  distributorSaleList: {
    page: 1,
    page_size: 20,
    more: false,
    list: [],
    kind: 2,
    total: 0,
    current_amount: 0,
  },
}

export const getVerifyUser = async (params: any) => {
  const resp = await http.post('/live/account/get_member_info_by_show_id', {
    ...params,
  })
  return resp.data
}

export const DistributorManageSlice = createSlice({
  name: 'DistributorManage',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDistributorList.fulfilled, (state, action) => {
      const {data} = action.payload
      if (data.kind === 0) {
        // 获取有邀请记录的list
        Object.assign(state, {
          invitedDistributorList: {
            ...data,
            list:
              data.page === 1
                ? [...data.list]
                : [...state.invitedDistributorList.list, ...data.list],
          },
        })
      } else {
        // 获取有效的邀请List
        Object.assign(state, {
          distributorList: {...data},
        })
      }
    })
    // builder.addCase(rechargeAgencyTrade.fulfilled, (state, action) => {
    //   const {err_msg, status} = action.payload
    //   if (status === 2 && err_msg) {
    //     onlyToast(err_msg)
    //   }
    // })
    builder.addCase(seniorInviteDistributor.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(seniorTradeHis.fulfilled, (state, action) => {
      const {data} = action.payload
      if (data.kind === 1) {
        // 分销记录
        Object.assign(state, {
          tradeRecordList: {
            ...data,
            list:
              data.page === 1
                ? [...data.list]
                : [...state.tradeRecordList.list, ...data.list],
          },
        })
      } else {
        // 分销商卖币记录
        Object.assign(state, {
          distributorSaleList: {
            ...data,
            list:
              data.page === 1
                ? [...data.list]
                : [...state.distributorSaleList.list, ...data.list],
          },
        })
      }
    })
  },
})

export default DistributorManageSlice.reducer
export const DistributorManageAction = DistributorManageSlice.actions
